'use client'

import { useHomeRedirect } from 'links/home/client/useHomeRedirect'
import { PREVIOUS_URL_KEY } from 'links/login/constants'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { useSession } from 'session/src/hooks/useSession'
import {
	getFromSessionStorage,
	removeFromSessionStorage,
} from 'utils/webStorage/sessionStorage'

export function RedirectOnLogged() {
	const { isReady, logged } = useSession()
	const pathname = usePathname()
	const { homeReplace } = useHomeRedirect()

	useEffect(() => {
		if (!isReady || !logged) {
			return
		}

		const sessionstorageurl = getFromSessionStorage<string>(PREVIOUS_URL_KEY)
		const isSamePageAsStorage = sessionstorageurl === pathname
		removeFromSessionStorage(PREVIOUS_URL_KEY)
		const isRecoveryPasswordPage =
			sessionstorageurl?.includes('/reset-password')

		if (sessionstorageurl && !isSamePageAsStorage && !isRecoveryPasswordPage) {
			window.location.replace(sessionstorageurl)
			return
		}

		const referrer = document?.referrer
		const hostname = window?.location?.hostname
		const href = window?.location?.href
		const isMngPage = referrer?.includes(hostname)
		const isSamePageAsReferrer = referrer === href

		if (isMngPage && !isSamePageAsReferrer && !isRecoveryPasswordPage) {
			window.location.replace(referrer)
			return
		}

		homeReplace()
	}, [isReady, logged])

	return null
}
